// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HddFilledSvg from "@fishx/icons-svg/es/asn/HddFilled";
import FishxIcon from '../components/FishxIcon';

var HddFilled = function HddFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: HddFilledSvg
  }));
};

HddFilled.displayName = 'HddFilled';
export default React.forwardRef(HddFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/HddFilled.js
// module id = 2912
// module chunks = 0